(function () {
  const init = () => {
    const filters = document.querySelectorAll("[data-collection-filter]");
    if (!filters.length) return;

    filters.forEach((root) => {
      if (root.dataset.filterInitialized === "true") return;
      root.dataset.filterInitialized = "true";

      const trigger = root
        .querySelector("[data-filter-label]")
        ?.closest("button");
      const panel = root.querySelector("[data-filter-panel]");
      const options = Array.from(root.querySelectorAll("[data-filter-option]"));
      const searchInput = root.querySelector("[data-filter-search]");
      const clearBtn = root.querySelector("[data-filter-clear]");
      const label = root.querySelector("[data-filter-label]");
      if (!trigger || !panel || !label) return;

      // Elements for filtering products
      const form = root.matches("[data-filter-form]") ? root : root.querySelector("[data-filter-form]");
      const productGrid = document.getElementById("ResultsList");
      const resultsList = document.querySelector("results-list[section-id]");
      const sectionId = resultsList?.getAttribute("section-id");
      let abortController = null;

      const baseLabel = "Filter";

      const updateLabel = () => {
        const checked = root.querySelectorAll(
          ".collection-filter__checkbox:checked"
        ).length;
        if (checked === 0) {
          label.textContent = baseLabel;
        } else {
          label.textContent = `${checked} selected`;
        }
      };

      const updateProducts = () => {
        if (!form) return;

        const formData = new FormData(form);
        const params = new URLSearchParams(formData);
        const url = `${window.location.pathname}?${params.toString()}`;

       
        if (!productGrid || !sectionId) {
          window.location.href = url;
          return;
        }

        productGrid.style.opacity = "0.5";
        productGrid.style.pointerEvents = "none";

        if (abortController) abortController.abort();
        abortController = new AbortController();

        const sectionUrl = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;

        fetch(sectionUrl, { signal: abortController.signal })
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const freshGrid = doc.getElementById("ResultsList");
            if (freshGrid) {
              productGrid.innerHTML = freshGrid.innerHTML;
              window.history.pushState({}, "", url);
            }
          })
          .catch((error) => {
            if (error.name !== "AbortError") {
              console.error("Filter error:", error);
            }
          })
          .finally(() => {
            productGrid.style.opacity = "1";
            productGrid.style.pointerEvents = "";
          });
      };

      const openPanel = () => {
        panel.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        panel.setAttribute("data-open", "true");

        // Close the Sort by dropdown when Filter opens
        const sortDetails = document.querySelector(".collection-subheader__dropdown");
        if (sortDetails && sortDetails.open) {
          sortDetails.removeAttribute("open");
        }
      };

      const closePanel = () => {
        panel.hidden = true;
        trigger.setAttribute("aria-expanded", "false");
        panel.removeAttribute("data-open");
      };

      const togglePanel = () => {
        const isOpen = trigger.getAttribute("aria-expanded") === "true";
        if (isOpen) {
          closePanel();
        } else {
          openPanel();
        }
      };

      trigger.addEventListener("click", togglePanel);

      // Close the Filter panel when Sort by is clicked
      const sortSummary = document.querySelector(".collection-subheader__dropdown > summary");
      if (sortSummary) {
        sortSummary.addEventListener("click", () => {
          closePanel();
        });
      }

      document.addEventListener("click", (event) => {
        if (!root.contains(event.target)) {
          closePanel();
        }

        // Also close Sort by if clicking outside of it
        const sortDetails = document.querySelector(".collection-subheader__dropdown");
        if (sortDetails && sortDetails.open && !sortDetails.contains(event.target)) {
          sortDetails.removeAttribute("open");
        }
      });

      options.forEach((option) => {
        const checkbox = option.querySelector(".collection-filter__checkbox");
        if (!checkbox) return;
        checkbox.addEventListener("change", () => {
          updateLabel();
          updateProducts();
        });
      });

      if (clearBtn) {
        clearBtn.addEventListener("click", () => {
          options.forEach((option) => {
            const checkbox = option.querySelector(
              ".collection-filter__checkbox"
            );
            if (checkbox) {
              checkbox.checked = false;
            }
          });
          updateLabel();
          updateProducts();
        });
      }

      if (searchInput) {
        searchInput.addEventListener("input", () => {
          const term = searchInput.value.trim().toLowerCase();
          options.forEach((option) => {
            const textEl = option.querySelector(
              ".collection-filter__option-text"
            );
            if (!textEl) return;
            const match = textEl.textContent
              .trim()
              .toLowerCase()
              .includes(term);
            option.classList.toggle("is-hidden", !match);
          });
        });
      }

      window.addEventListener("popstate", () => {
        window.location.reload();
      });

      updateLabel();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
